export const getExperiments = () => {
  if (!global.window) return {};

  return Object.values(global.gaData || {})
    .map(f => f.experiments)
    .reduce((acc, experiment) => Object.assign(acc, experiment || {}), {});
}

export const isExperiment = () => !!Object.entries(getExperiments())
  .filter(([, version]) => parseInt(version, 10))[0];